import { render, staticRenderFns } from "./RankingsPerPage.vue?vue&type=template&id=fcc16f9a"
import script from "./RankingsPerPage.vue?vue&type=script&lang=js"
export * from "./RankingsPerPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports